import { render, staticRenderFns } from "./acFooter.vue?vue&type=template&id=4bd5d66f&scoped=true&"
import script from "./acFooter.vue?vue&type=script&lang=js&"
export * from "./acFooter.vue?vue&type=script&lang=js&"
import style0 from "./acFooter.vue?vue&type=style&index=0&id=4bd5d66f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd5d66f",
  null
  
)

export default component.exports